import React, { useState } from "react";

interface CaptionedImageProps {
  src: string;
  alt: string;
  caption?: string;
  maxWidth?: string | number;
  captionPosition?: "bottom" | "right";
}

export const LightboxImage: React.FC<CaptionedImageProps> = ({
  src,
  alt,
  caption,
  maxWidth,
  captionPosition = "bottom",
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const openLightbox = () => setIsOpen(true);
  const closeLightbox = () => setIsOpen(false);

  const figureStyle = {
    maxWidth: maxWidth,
  };

  // Determine the figure layout based on captionPosition instead of returning early so that
  // the lightbox modal can still be rendered alongside the figure.
  const figureContent =
    captionPosition === "right" ? (
      // Layout for caption on the right: stack vertically on small screens and side-by-side on larger ones.
      <figure
        style={figureStyle}
        className="mx-auto my-4 grid grid-cols-1 md:grid-cols-2 gap-4 items-start w-full cursor-pointer"
        onClick={openLightbox}
      >
        <img
          src={src}
          alt={alt}
          className="rounded-md w-full h-auto object-contain"
        />
        <figcaption className="text-sm italic text-center md:text-left self-center md:self-start">
          {caption}
        </figcaption>
      </figure>
    ) : (
      // Default layout for caption at the bottom
      <figure
        style={figureStyle}
        className="mx-auto my-4 cursor-pointer"
        onClick={openLightbox}
      >
        <img src={src} alt={alt} className="rounded-md w-full h-auto" />
        {caption && (
          <figcaption className="mt-2 text-sm text-center text-gray-600 italic">
            {caption}
          </figcaption>
        )}
      </figure>
    );

  return (
    <>
      {figureContent}

      {/* Lightbox Modal */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50"
          onClick={closeLightbox}
        >
          <div
            className="relative bg-white rounded-lg max-w-[90vw] max-h-[90vh] px-8 py-4"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute top-0 right-2 text-black text-2xl font-bold"
              onClick={closeLightbox}
            >
              &times;
            </button>
            <img
              src={src}
              alt={alt}
              className="max-w-full max-h-[85vh] object-contain"
            />
            {caption && (
              <div className="mt-2 text-sm text-center text-gray-800 italic">
                {caption}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};
